import EL, { HTMLELEMENT } from '../../EL/EL.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import Translatable from '../../../interface/Translatable.js';
// Model Structure
export const textAttr = makeAttrStruct([
    ['class'],
    ['style'],
    ['title']
]);
export const textData = makeDataStruct([
    ['text', ''],
    ['textGroup', ''],
    ['textKey', '']
]);
export const textModel = makeStruct([
    ['attributes', textAttr],
    ['data', textData]
]);
/** A generic TEXT element */
export function text(text, className, textGroup, textKey) {
    return {
        attributes: textAttr(className),
        data: textData(text, textGroup, textKey)
    };
}
/** An abstract TEXT wrapper Element class */
export default class TEXT extends EL {
    constructor(node, element, model) {
        super(node, element, model);
        if (model.data.textKey && model.data.textGroup) {
            this.implement(new Translatable(this));
        }
        this.setInnerHTML(model.data.text);
    }
}
export { EL, HTMLELEMENT };
